<div [ngStyle]="{ background: 'url(assets/images/MARSBanner.png)' }" class="content-header">
  <h2 class="header-title">MARS <span class="parenthetical">(Malfunctions & Abnormalities)</span></h2>
  <h3 class="header-subtitle">{{marsIncidentForm.get('incidentId').value === 0 ? 'Create' : 'Edit'}} Incident</h3>
</div>
<app-spinner [active]="isLoading"></app-spinner>
<mat-stepper #stepper orientation="horizontal" linear="false" class="incident-stepper">
  <mat-step label="Incident" completed="false">
    <div class="step-container">
      <ng-template matStepLabel>{{marsIncidentForm.get('incidentId').value === 0 ? 'Add information about the malfunction or abnormality' : 'Incident' }}</ng-template>
      <app-incident [form]="marsIncidentForm"></app-incident>
      <div class="buttons">
        <button class="primary-btn" [disabled]="!checkInitialValidation()" mat-button (click)="saveIncident(0)" *ngIf="marsIncidentForm.get('status').value !== 1"><mat-icon class="btn-icon">schedule</mat-icon>{{marsIncidentForm.get('incidentId').value === 0 ? 'Create New Incident Draft' : 'Save Draft'}}</button>
        <button color="primary" mat-button matStepperNext *ngIf="marsIncidentForm.get('incidentId').value !== 0">Next</button>
      </div>
    </div>
  </mat-step>
  <div *ngIf="marsIncidentForm.get('incidentId').value !== 0">
    <mat-step label="Jumper" completed="false">
      <div class="step-container">
        <ng-template matStepLabel>Jumper</ng-template>
        <app-jumper [form]="marsIncidentForm"></app-jumper>
        <div class="buttons">
          <button color="primary" mat-button matStepperPrevious>Back</button>
          <button class="primary-btn" mat-button (click)="saveIncident(0)" *ngIf="marsIncidentForm.get('status').value !== 1"><mat-icon class="btn-icon">schedule</mat-icon>Save Draft</button>
          <button color="primary" mat-button matStepperNext>Next</button>
        </div>
      </div>
    </mat-step>
    <mat-step label="Parachutes" completed="false">
      <div class="step-container">
        <ng-template matStepLabel data-cy="testing-step">Parachutes</ng-template>
        <app-parachutes [form]="marsIncidentForm"></app-parachutes>
        <div class="buttons">
          <button color="primary" mat-button matStepperPrevious>Back</button>
          <button class="primary-btn" mat-button (click)="saveIncident(0)" *ngIf="marsIncidentForm.get('status').value !== 1"><mat-icon class="btn-icon">schedule</mat-icon>Save Draft</button>
          <button color="primary" mat-button matStepperNext>Next</button>
        </div>
      </div>
    </mat-step>
    <mat-step label="Artifacts" completed="false">
      <div class="step-container">
        <ng-template matStepLabel>Artifacts</ng-template>
        <app-artifacts-info [form]="marsIncidentForm"></app-artifacts-info>
        <div class="buttons">
          <button color="primary" mat-button matStepperPrevious>Back</button>
          <button class="primary-btn" mat-button (click)="saveIncident(0)" *ngIf="marsIncidentForm.get('status').value !== 1"><mat-icon class="btn-icon">schedule</mat-icon>Save Draft</button>
          <button color="primary" mat-button matStepperNext>Next</button>
        </div>
      </div>
    </mat-step>
    <mat-step label="Summary" completed="false">
      <div class="step-container summary">
        <ng-template matStepLabel>Summary</ng-template>
        <app-summary [form]="marsIncidentForm"></app-summary>
        <div class="buttons">
          <button color="primary" mat-button matStepperPrevious>Back</button>
          <button class="primary-btn" mat-button (click)="saveIncident(0)" *ngIf="marsIncidentForm.get('status').value !== 1"><mat-icon class="btn-icon">schedule</mat-icon>Save Draft</button>
          <button 
          class="primary-btn" 
          mat-button 
          (click)="saveIncident(0)" 
          *ngIf="user.isMarsAdmin && marsIncidentForm.get('status').value === 1"
          ><mat-icon class="btn-icon">schedule</mat-icon>Open Draft Mode</button>
          <button 
          *ngIf="(marsIncidentForm.get('createUser').value === user.email || user.isMarsAdmin) && (marsIncidentForm.get('status').value !== 1)" 
          class="primary-btn finalize"
          mat-button 
          (click)="modal.active = true"
          ><mat-icon class="btn-icon">lock</mat-icon>Finalize </button>
          <app-tool-tip 
            [title]="'Finalize Incident'" 
            [listItems]="['Only the creator of the incident or a MARS Admin can finalize an incident.', 'Once an incident is finalized, it will be locked and no longer editable.', 'Only MARS Admin can convert it back to a draft for editing', 'If the incident still has values that need to be updated by yourself or others, just save the draft.']"
            ></app-tool-tip>
        </div>
      </div>
    </mat-step>
  </div>
  <ng-template matStepperIcon="number">
    <mat-icon><i class="mat-step-custom-icon"></i></mat-icon>
  </ng-template>
  <ng-template matStepperIcon="edit">
    <mat-icon><i class="mat-step-custom-icon"></i></mat-icon>
  </ng-template>
</mat-stepper>
<app-modal
  [active]="modal.active"
  [data]="modal.data"
  (confirmed)="saveIncident(1)"
  (secondary)="saveIncident(0)"
  (denied)="modal.active = false"
>
</app-modal>